import axios from '../utils/axios';

export default function fetchNTCPremiumJobRejectionStats(adminId, params) {
    return axios.get(`/admin/${adminId}/ntc-premium-jobs/rejection-stats`, { params })
        .then(res => res.data)
        .catch(err => err);
}
